// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-modal-styles-module__overlay--GDOsx {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
}

.src-js-components-modal-styles-module__modal--XMzfF {
  position: absolute;
  top: 40px;
  left: 40px;
  right: 40px;
  margin: 20px auto;
  background-color: #7d7d7d;
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  outline: none;
  z-index: 100;
}

.src-js-components-modal-styles-module__large--Ltc8s {
  max-width: 700px;
}

.src-js-components-modal-styles-module__medium--WfQ7F {
  max-width: 500px;
}

.src-js-components-modal-styles-module__title--SVRYT {
  background: #071c35;
  color: #ffffff;
  padding: 5px 10px;
  font-size: 18px;
}

.src-js-components-modal-styles-module__title--SVRYT a {
  color: #ffffff;
}

.src-js-components-modal-styles-module__title--SVRYT a:hover {
  color: #ffdaa0;
}

.src-js-components-modal-styles-module__cancelX--LkGFg {
  margin-top: 3px;
  float: right;
}

.src-js-components-modal-styles-module__content--pvjnm {
  background: #ffffff;
  color: #071c35;
  padding: 10px;
  max-height: 500px;
  overflow: auto;
}

.src-js-components-modal-styles-module__actions--WSNua {
  margin-top: 30px;
  float: right;
  background: #ffffff;
}

.src-js-components-modal-styles-module__button--KnrF_ {
  display: inline-block;
  margin-right: 5px;
  font-weight: 400;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/modal/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".overlay {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 99;\n}\n\n.modal {\n  position: absolute;\n  top: 40px;\n  left: 40px;\n  right: 40px;\n  margin: 20px auto;\n  background-color: #7d7d7d;\n  padding: 15px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n  outline: none;\n  z-index: 100;\n}\n\n.large {\n  max-width: 700px;\n}\n\n.medium {\n  max-width: 500px;\n}\n\n.title {\n  background: #071c35;\n  color: #ffffff;\n  padding: 5px 10px;\n  font-size: 18px;\n}\n\n.title a {\n  color: #ffffff;\n}\n\n.title a:hover {\n  color: #ffdaa0;\n}\n\n.cancelX {\n  margin-top: 3px;\n  float: right;\n}\n\n.content {\n  background: #ffffff;\n  color: #071c35;\n  padding: 10px;\n  max-height: 500px;\n  overflow: auto;\n}\n\n.actions {\n  margin-top: 30px;\n  float: right;\n  background: #ffffff;\n}\n\n.button {\n  display: inline-block;\n  margin-right: 5px;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `src-js-components-modal-styles-module__overlay--GDOsx`,
	"modal": `src-js-components-modal-styles-module__modal--XMzfF`,
	"large": `src-js-components-modal-styles-module__large--Ltc8s`,
	"medium": `src-js-components-modal-styles-module__medium--WfQ7F`,
	"title": `src-js-components-modal-styles-module__title--SVRYT`,
	"cancelX": `src-js-components-modal-styles-module__cancelX--LkGFg`,
	"content": `src-js-components-modal-styles-module__content--pvjnm`,
	"actions": `src-js-components-modal-styles-module__actions--WSNua`,
	"button": `src-js-components-modal-styles-module__button--KnrF_`
};
export default ___CSS_LOADER_EXPORT___;
